import { useTranslation } from "react-i18next";

import { DownloadIcon } from "~/components/ui/icons/download";
import type { OrderQuery } from "~/graphql/graphql-new.gen";

export type OrderAttachmentsProps = {
  claim?: OrderQuery["order"]["claims"][0];
};

export const OrderAttachments: React.FC<OrderAttachmentsProps> = ({
  claim,
}: OrderAttachmentsProps) => {
  const { t } = useTranslation();

  if (!claim?.swornStatementUrls.length) return null;

  return (
    <div className="mt-4 flex flex-col gap-4 border-t border-gray-300 pt-4">
      <h5 className="text-sm font-semibold text-gray-900">
        {t("order.attachments")}
      </h5>
      <ul className="flex flex-col gap-4">
        {claim.swornStatementUrls.map((url) => (
          <li key={url}>
            <a
              href={url}
              className="flex gap-x-1 text-xs font-semibold text-green-900"
              target="_blank"
              rel="noreferrer"
            >
              <DownloadIcon className="size-4" />
              {t("order.claim.sworn_attachment")}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
